import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import helpers from 'app/helpers/rubrics';

const {OptionStyles} = helpers;

class RubricCritOpt extends React.PureComponent {
  render() {
    const {label, value, style, size, selected, onClick, staticTag, canChange, className, flex} = this.props;
    const showVal = value != null;
    const selectedClass = selected ? 'selected' : '';
    const staticClass = staticTag ? 'static' : '';
    const isBold = style.startsWith('bold-');
    const styleColor = isBold ? style.split('-')[1] : style;
    const boldClass = isBold ? 'bold' : '';
    const changeClass = canChange ? '' : 'no-click';

    return (
      <button className={`rub-crit-opts-opt style-${styleColor} size-${size} ${selectedClass} ${staticClass} ${boldClass} ${changeClass} ${className}`} onClick={onClick}>
        <span className="rub-crit-opts-opt-label">{label}</span>
        {showVal && (
          <span className="rub-crit-opts-opt-value">{value}</span>
        )}
      </button>
    );
  }
}
RubricCritOpt.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.oneOf(Object.values(OptionStyles)).isRequired,
  size: PropTypes.oneOf(['xs', 'small', 'regular']),
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  staticTag: PropTypes.bool,
  className: PropTypes.string,
  canChange: PropTypes.bool,
};
RubricCritOpt.defaultProps = {
  size: 'regular',
  selected: false,
  staticTag: false,
  className: '',
  canChange: true,
};



class RubricCritOpts extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedValue: null,
    };
  }

  get value() {
    if (this.props.onChange) return this.props.value;
    return this.state.selectedValue;
  }

  onClickOpt(opt, i) {
    if (this.props.staticTags) return;
    const isSelected = opt.value === this.value;
    if (this.props.onChange) {
      this.props.onChange(this.props.crit, (isSelected ? null : opt));
    } else {
      const selectedValue = isSelected ? null : opt.value;
      this.setState({selectedValue});
    }
  }

  render() {
    const {options, size, showVals, staticTags, className, flex} = this.props;
    const {value} = this;
    const flexClass = flex ? 'flex' : '';
    // const fakes = new Array(10).fill(42);
    return (
      <div className={`rub-crit-opts size-${size} ${flexClass} ${className}`}>
        {options.map((option, i) => {
          const selected = option.value === value;
          return (
            <RubricCritOpt
              key={i}
              label={option.label}
              value={showVals ? option.value : null}
              style={option.style}
              size={size}
              selected={selected}
              onClick={this.onClickOpt.bind(this, option, i)}
              staticTag={staticTags}
            />
          );
        })}
        {/* {fakes.map((foo, i) => { */}
        {/*   return <div key={i} className="rub-crit-opts-fake-opt" />; */}
        {/* })} */}
      </div>
    );
  }

}

RubricCritOpts.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    style: PropTypes.oneOf(Object.values(OptionStyles)),
  })).isRequired,
  size: PropTypes.oneOf(['xs', 'small', 'regular']),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  crit: PropTypes.object,
  onChange: PropTypes.func,
  showVals: PropTypes.bool,
  staticTags: PropTypes.bool,
  className: PropTypes.string,
  flex: PropTypes.bool,
};
RubricCritOpts.defaultProps = {
  options: [],
  size: 'regular',
  showVals: false,
  staticTags: false,
  className: '',
  flex: false,
};

RubricCritOpts.Single = RubricCritOpt;

export default RubricCritOpts;
